/**
 * Daily clearance spotlight for guests and free accounts: once a local day, a
 * card on the home page saying how many in-store clearance deals one nearby
 * chain has right now. The chain rotates by day so the pitch changes.
 */

export const DAILY_SPOTLIGHT_SHOWN_KEY = "dealhawk_daily_clearance_shown_day";

/** Rotation order; the first with deals near the ZIP is the day's pick. */
export const SPOTLIGHT_CHAINS = ["walmart", "target", "home_depot", "bestbuy", "dollar_general", "costco"] as const;
export type SpotlightChain = (typeof SPOTLIGHT_CHAINS)[number];

/** The device's local calendar day, e.g. "2026-11-03". */
export function localDayKey(now: Date = new Date()): string {
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}

export function shouldShowDailySpotlight(lastShownDay: string | null, today: string): boolean {
  return lastShownDay !== today;
}

/** Every chain, starting with the day's chain, so a day with no deals there falls through to the next. */
export function spotlightChainsForDay(dayKey: string): SpotlightChain[] {
  const [year, month, day] = dayKey.split("-").map(Number);
  const dayNumber = Math.floor(Date.UTC(year, (month || 1) - 1, day || 1) / 86_400_000);
  const start = ((dayNumber % SPOTLIGHT_CHAINS.length) + SPOTLIGHT_CHAINS.length) % SPOTLIGHT_CHAINS.length;
  return [...SPOTLIGHT_CHAINS.slice(start), ...SPOTLIGHT_CHAINS.slice(0, start)];
}
